import { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { api_getBannersByBannerGroupName } from '~/backend/api_calls';
import { convertImageUrl_L_to_M } from '~/backend/helper';

const DoubleBanner = () => {
	const [banners, setBanners] = useState([]);
	const groupName = 'DoubleBanner';

	// Runs once after init rendering
	useEffect(() => {
		api_getBannersByBannerGroupName(groupName)
			.then(json => {
				setBanners(json.items);
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	if (banners.length === 0) return null;

	return (
		<section id="double-banner">
			{banners.map(item =>
				!item.nu ? (
					<div className="banner-item" key={item.id}>
						<picture>
							<source
								media="(max-width:480px)"
								src={convertImageUrl_L_to_M(item.img2) ?? item.img1}
								srcSet={convertImageUrl_L_to_M(item.img2) ?? item.img1}
							/>
							<img src={convertImageUrl_L_to_M(item.img1)} alt={item.tl} height="960" width="960" />
							<div className="title-container">
								<h3>{item.tl}</h3>
							</div>
						</picture>
					</div>
				) : (
					<Link className="banner-item" key={item.id} to={item.nu}>
						<picture>
							<source
								media="(max-width:480px)"
								src={convertImageUrl_L_to_M(item.img2) ?? item.img1}
								srcSet={convertImageUrl_L_to_M(item.img2) ?? item.img1}
							/>
							<img src={convertImageUrl_L_to_M(item.img1)} alt={item.tl} height="960" width="960" />
							<div className="title-container">
								<h3>{item.tl}</h3>
							</div>
						</picture>
					</Link>
				)
			)}
		</section>
	);
};

export default DoubleBanner;
